module.exports = __webpack_public_path__ + "static/media/screen1.95b571b8.png";